"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentEventBusEventBridgeCollector = exports.ContainerEventBusBridgeEventCollector = void 0;
const eventBus_1 = require("../eventBus");
const types_1 = require("./types");
class ContainerEventBusBridgeEventCollector extends types_1.EventCollector {
    constructor() {
        super(...arguments);
        this.eventBridge = null;
        this.init = (eventBus) => {
            this.eventBus = eventBus;
            window.createEventCollector = (contentEventBus) => {
                try {
                    if (!this.eventBus) {
                        throw new Error('EventCollector is not preconfigured. ContentEventBus is not defined');
                    }
                    else {
                        this.eventBridge = eventBus_1.EventBusesBridge.create([contentEventBus, this.eventBus]);
                    }
                }
                catch (error) {
                    console.error('Error initializing EventCollector', error);
                }
            };
        };
    }
}
exports.ContainerEventBusBridgeEventCollector = ContainerEventBusBridgeEventCollector;
class ContentEventBusEventBridgeCollector extends types_1.EventCollector {
    constructor() {
        super(...arguments);
        this.init = (eventBus) => {
            this.eventBus = eventBus;
            if (!window.createEventCollector) {
                throw new Error('EventCollector is not preconfigured. window.createEventCollector is not defined');
            }
            window.createEventCollector(this.eventBus);
        };
    }
}
exports.ContentEventBusEventBridgeCollector = ContentEventBusEventBridgeCollector;
//# sourceMappingURL=EventBusBridge.js.map